import type { EditorAPI } from '#packages/editorAPI';
import { PanelResolveType } from '@wix/platform-editor-sdk';
import { translate } from '#packages/i18n';
import { bi } from '#packages/tpa';
import * as stateManagement from '#packages/stateManagement';

export const updateCollapseMenuIfNeeded = (
  editorAPI: EditorAPI,
  pageId: string,
  isCollapsed: boolean,
) => {
  let collapsedMap =
    stateManagement.userPreferences.selectors.getSessionUserPreferences(
      'collapsedMenuItems',
    )(editorAPI.store.getState()) as Record<string, boolean>;

  if (!collapsedMap) {
    // NOTE: https://github.com/wix-private/santa-editor/pull/20942#discussion_r331974822
    editorAPI.store.dispatch(
      stateManagement.userPreferences.actions.setSessionUserPreferences(
        'collapsedMenuItems',
        {},
      ),
    );
    collapsedMap = {};
  }
  collapsedMap = Object.assign({}, collapsedMap, {
    [`${pageId}_replacersCollapser`]: Boolean(isCollapsed),
  });

  editorAPI.store.dispatch(
    stateManagement.userPreferences.actions.setSessionUserPreferences(
      'collapsedMenuItems',
      collapsedMap,
    ),
  );
};

async function deleteReplacerAppAndResetModal(
  editorAPI: EditorAPI,
  appDefinitionId: string,
): Promise<{ status: PanelResolveType }> {
  if (!appDefinitionId) {
    throw new Error(
      'in order to delete an app, you must pass appDefinitionId.',
    );
  }
  const appData = editorAPI.platform.getAppDataByAppDefId(appDefinitionId);
  if (appData) {
    editorAPI.bi.event(bi.events.TPA_MESSAGE_LOADED, {
      app_id: appDefinitionId,
      description: 'page_replace_app_delete',
      type: 'error_message',
    });
    const userAction = await editorAPI.platform.panels.openErrorPanel({
      helpId: '4b2cc9ee-1217-4293-9632-56e91eefd19a',
      headerText: translate(
        'PLATFORM_flow_customization_delete_app_modal_title',
      ),
      shouldShowIllustration: true,
      topDescriptionText: [
        {
          tag: 'p',
          content: translate(
            'PLATFORM_flow_customization_delete_app_modal_text',
            { app_name: appData.appDefinitionName },
          ),
        },
      ],
      secondaryActionText: translate(
        'PLATFORM_flow_customization_delete_app_modal_cancel_button',
      ),
      mainActionText: translate(
        'PLATFORM_flow_customization_delete_app_modal_delete_button',
      ),
    });
    return { status: userAction };
  }
}

export { deleteReplacerAppAndResetModal };
